
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { getStoryblokApi } from '@storyblok/react'
import {
  GetServerSidePropsContextWithLocale,
  InferGetServerSidePropsType,
} from 'next'
import { NextSeo } from 'next-seo'
import { SearchPage } from '@/app/common/components/SearchPage/SearchPage'
import { getWithRelationsAndLinks } from '@/app/common/storyblok'
import config from '@/config'
import {
  getConfigStory,
  getRegionCode,
  getSBRegionFolder,
} from '@/helpers/createGetServerSideProps'
import setCacheControl from '@/helpers/setCacheControl'
import {
  CardsGridReferenceStoryblok,
  SearchConfigStoryblok,
} from '@/types/storyblok-component-types'

export default function Search({
  title,
  categoriesBlok,
  suggestions,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <>
      <NextSeo title={title} noindex />
      <SearchPage categoriesBlok={categoriesBlok} suggestions={suggestions} />
    </>
  )
}

 async function _getServerSideProps(
  context: GetServerSidePropsContextWithLocale,
) {
  setCacheControl(context, true)
  const storyblokApi = getStoryblokApi()
  const regionCode = getRegionCode(context)
  const [searchConfigStory, configStory] = await Promise.all([
    getWithRelationsAndLinks({
      context,
      slug: config.isStoryblokDevSpace
        ? 'cdn/stories/search-config'
        : `cdn/stories/${getSBRegionFolder(regionCode)}/search-config`,
      storyblokApi,
      params: {
        resolve_relations: ['cards-grid-reference.cards_grid'],
      },
    }),
    getConfigStory({ storyblokApi, regionCode, context }),
  ])

  const searchConfig = searchConfigStory?.data.story
    .content as SearchConfigStoryblok

  if (!(searchConfig && configStory)) {
    return { notFound: true }
  }

  return {
    props: {
      title: searchConfig.title,
      categoriesBlok: Array.isArray(searchConfig.categories)
        ? (searchConfig.categories[0] as CardsGridReferenceStoryblok)
        : null,
      suggestions:
        typeof searchConfig.suggestions === 'string'
          ? searchConfig.suggestions.split(',')
          : [],
      regionCode,
      config: configStory.data.story?.content,
    },
  }
}


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/search',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  